//
import { mapActions } from "vuex"
import { ModelForm } from "@/components/reusable_components/next"
import Translator from "@/services/translator"

//
import PosCashDeskModel from "@/models/POS/PosCashDesk"
import fields from "./fields"

//
export default {
    name: "pos-cash-desk-create",
    components: {
        "model-form": ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                fields,
            }
        },
    },
    data () {
        return {
            formData: {},
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setAppToolbarTitle: "setAppToolbarTitle",
        }),

        /**
         * 
         */
        create ( model ) {
            model.toCreate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( PosCashDeskModel, error.response.data ) )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "pos-cash-desk-list" })
        },

        /**
         * 
         */
        reset () {
            this.formData = new PosCashDeskModel()
        },

        /**
         *
         */
        showSnackbar ( type, title, message ) {
            this.initSnackbar( this.fillSnack( type, title, message ) )
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.create )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Caja agregada." )
        },
    },
    beforeMount () {
        this.setAppToolbarTitle({ title: "Crear caja" })
    },
    mounted () {
        this.reset()
    }
}